<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<!--
// -----------------------------------------------------------------------------
// <copyright file="select.component.html" company="ecoInsight, Inc.">
// Copyright © ecoInsight, Inc. All rights reserved.
// </copyright>
// ------------------------------------------------------------------------------ -->

<div class="eselect" [class.disabled]="disabled()">
  <span class="ei-select-icons" tabindex="0" role="button" (click)="onIconClick($event)">
    <i class="i-oval-s"></i>
    <i aria-hidden="true" class="i-darrow"></i>
  </span>
  @if (control.value) {
    <label class="{{ control.value ? 'active' : '' }}">{{ placeholder() }}</label>
  }
  <input
    #txt
    maxlength="128"
    [readonly]="!editable()"
    autocomplete="off"
    [tabindex]="disabled() ? -1 : 0"
    class="form-control {{ control.value ? 'active' : '' }} {{ 'ei-select-input' + id() }}"
    [placeholder]="placeholder()"
    type="text"
    (focus)="onFocus($event)"
    (blur)="onBlur()"
    (keyup)="onKeyup($event)"
    [formControl]="control"
  />
</div>
